import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "features/application/reset-password/view.scss";

const ResetPasswordView = ({
  responseCodes,
  errorCodes,
  formReference,
  sendApiRequest,
}) => (
  <form
    className="application__container"
    noValidate
    ref={formReference}
    onSubmit={sendApiRequest}
  >
    <h1 className="application__headline reset-password__headline">
      Forgot password?
    </h1>
    {!responseCodes.resetPassword && (
      <Fragment>
        <p className="authentication__description">
          <span className="authentication__description--light">
            We just need your registered e-mail adress to send you a password
            reset code.
          </span>
        </p>
        <div className="authentication__container">
          <Field
            label="E-mail address"
            name="email"
            type="email"
            maxLength={320}
            shouldValidate={true}
            rule="email"
            error="It doesn't look like a valid e-mail address."
          />
        </div>
      </Fragment>
    )}
    {responseCodes.resetPassword && (
      <p className="authentication__information">
        Check your inbox for a password reset email. Click on the URL provided
        in the email and enter a new password.
      </p>
    )}
    {errorCodes.resetPassword && (
      <p className="authentication__information">
        Something went wrong. Please try again later.
      </p>
    )}
    {!responseCodes.resetPassword && (
      <input
        className="application__button"
        type="submit"
        value="Reset my password"
      />
    )}
  </form>
);

ResetPasswordView.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  formReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default ResetPasswordView;
